module.exports = __webpack_public_path__ + "static/img/wksq_1.15700f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/wksq_1.jpg
// module id = 3VRL
// module chunks = 15